import { Component, OnInit, Input } from '@angular/core';
import { CommonUtilty , AppMetadataHandler } from 'app/BaseFramework';
import { LookupDataService } from 'app/BaseFramework/core/http/lookupdata.service';
import { WorkqueueService } from 'app/BaseFramework/core/http/workqueue.service';
import * as _ from 'lodash';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-stage-timeline',
  templateUrl: './stage-timeline.component.html',
  styleUrls: ['./stage-timeline.component.scss']
})
export class StageTimelineComponent implements OnInit {

  constructor(private lookupDataService: LookupDataService,
    private commonUtility: CommonUtilty,
    private appMetadataHandler: AppMetadataHandler,
    private workQueueService: WorkqueueService) { }

  @Input() workQueueItem;
  journey : string = 'NBU Journey'
  ngOnInit(): void {
    this.getStageList();
    let currentStageData = this.stageList.filter(item => item.lookupKey == this.workQueueItem.stageCd)
    this.currentStage = currentStageData ? currentStageData[0] ? currentStageData[0].sortOrder ? currentStageData[0].sortOrder : 0 : 0 : 0; 
    this.getAuditData();
  }

  stageList = [];
  currentStage = null;
  getStageList() {
    if(!this.commonUtility.isArrayIterable(this.appMetadataHandler['stageList'])){
    this.lookupDataService.getLookup('policyStageCd').subscribe(resp => {
      if (resp && this.commonUtility.isArrayIterable(resp)) {
        this.stageList = _.sortBy(resp, 'sortOrder');
        this.stageList = this.stageList.filter(item => item.lookupKey != 'CLAIMREJECT');
        let currentStageData = this.stageList.filter(item => item.lookupKey == this.workQueueItem.stageCd)
        this.currentStage = currentStageData ? currentStageData[0] ? currentStageData[0].sortOrder ? currentStageData[0].sortOrder : 0 : 0 : 0; 
        this.appMetadataHandler['stageList'] = [...this.stageList];
        this.removeStages(this.stageList)
        let activeIndx = this.workQueueItem ? this.stageList.findIndex(item => item.lookupKey == this.workQueueItem.stageCd) : -1;
        if (activeIndx > -1) {
          this.activateItem(activeIndx);
        } else {
          this.activateItem(0);
        }
      }else if(environment['demo']){
        resp = this.demoStageList;
        this.stageList = _.sortBy(resp, 'sortOrder');
        this.stageList = this.stageList.filter(item => item.lookupKey != 'CLAIMREJECT');
        this.appMetadataHandler['stageList'] = [...this.stageList];
        let activeIndx = this.workQueueItem ? this.stageList.findIndex(item => item.lookupKey == this.workQueueItem.stageCd) : -1;
        if (activeIndx > -1) {
          this.activateItem(activeIndx);
        } else {
          this.activateItem(0);
        }
      }

    })
  }else{
    this.stageList = [...this.appMetadataHandler['stageList']];
    this.removeStages(this.stageList)
    let activeIndx = this.workQueueItem ? this.stageList.findIndex(item => item.lookupKey == this.workQueueItem.stageCd) : -1;
    if (activeIndx > -1) {
      this.activateItem(activeIndx);
    } else {
      this.activateItem(0);
    }
  }
  }
  custom_stageLookup = []
  lastStage = []
  newlookup = []
  PENDING_DE_Lookup = []
  PENDING_COUNTER_OFFER_Lookup = []
  removeStages(stageList: any[]) {
    this.workQueueService.getWorkflowAudit(this.workQueueItem['guid'], "").subscribe(res => {
      if (res) {
        if (res && this.commonUtility.isArrayIterable(res) && res.length > 0) {
          res.forEach(stage => {
            let isAvailable = stageList.find(s => s.lookupKey === stage.stageCd);
            if (isAvailable) {
              let existingStage = this.custom_stageLookup.find(s => s.lookupKey === stage.stageCd);
              if (!existingStage) {
                this.custom_stageLookup.push(isAvailable);
              }
            }
        
            let isAvailableStage = stageList.find(s => s.lookupKey === this.workQueueItem.statusCd);
            if (isAvailableStage) {
              let existingStage = this.custom_stageLookup.find(s => s.lookupKey === this.workQueueItem.statusCd);
              if (!existingStage) {
                this.lastStage = isAvailableStage;
              }
            }
            
          })
          // last stage 

          if (this.lastStage['lookupKey'] == 'ISSUED' || this.lastStage['lookupKey'] == 'REJECTED' || this.lastStage['lookupKey'] == 'CONOTACCEPTED') {
            this.custom_stageLookup.push(this.lastStage);
          }
          // PENDING_MANUAL_UW , MUWCOMPLETE
          if(this.workQueueItem.stageCd == 'PENDING_MANUAL_UW' || this.workQueueItem.stageCd == 'MUWCOMPLETE'){
            let lookupKeysToFind = ['PENDING_COUNTER_OFFER', 'CONOTACCEPTED', 'ISSUED', 'REJECTED'];
            lookupKeysToFind.forEach(lookupKey => {
              let stage = stageList.find(s => s.lookupKey === lookupKey);
              if (stage) {
                let existingStage = this.custom_stageLookup.find(s => s.lookupKey === lookupKey);
                if (!existingStage) {
                  this.newlookup.push(stage);
                }
              }
            });
          }
          if (this.newlookup.length > 0) {
            this.newlookup.forEach(element => {
              this.custom_stageLookup.push(element);
            });
          }
          // PENDING_DE
          if(this.workQueueItem.stageCd == 'PENDING_DE'){
            let lookupKeysToFind = ['PENDING_AUTO_UW','MUWCOMPLETE','PENDING_MANUAL_UW','PENDING_COUNTER_OFFER', 'CONOTACCEPTED', 'ISSUED', 'REJECTED'];
            lookupKeysToFind.forEach(lookupKey => {
              let stage = stageList.find(s => s.lookupKey === lookupKey);
              if (stage) {
                let existingStage = this.custom_stageLookup.find(s => s.lookupKey === lookupKey);
                if (!existingStage) {
                  this.PENDING_DE_Lookup.push(stage);
                }
              }
            });
          }
          if (this.PENDING_DE_Lookup.length > 0) {
            this.PENDING_DE_Lookup.forEach(element => {
              this.custom_stageLookup.push(element);
            });
          }
          //PENDING_COUNTER_OFFER
          if(this.workQueueItem.stageCd == 'PENDING_COUNTER_OFFER'){
            let lookupKeysToFind = ['CONOTACCEPTED', 'ISSUED', 'REJECTED'];
            lookupKeysToFind.forEach(lookupKey => {
              let stage = stageList.find(s => s.lookupKey === lookupKey);
              if (stage) {
                let existingStage = this.custom_stageLookup.find(s => s.lookupKey === lookupKey);
                if (!existingStage) {
                  this.PENDING_COUNTER_OFFER_Lookup.push(stage);
                }
              }
            });
          }
          if (this.PENDING_COUNTER_OFFER_Lookup.length > 0) {
            this.PENDING_COUNTER_OFFER_Lookup.forEach(element => {
              this.custom_stageLookup.push(element);
            });
          }
         
        }
        console.log ("stagelist", this.custom_stageLookup)
      }
    })
  }
  activateItem(itemIndex: number) {
    for (let i = 0; i < this.stageList.length; i++) {
      if (i < itemIndex) {
        this.stageList[i].status = 'completed';
      } else if (i === itemIndex) {
        this.stageList[i].status = 'active';
      } else {
        this.stageList[i].status = 'pending';
      }
    }
  }

  workFlowAudit: any = [];
  getWorkflowAuditSubject$ = null;
  getAuditData() {

    if (this.getWorkflowAuditSubject$) this.getWorkflowAuditSubject$.unsubscribe();
    this.getWorkflowAuditSubject$ = this.workQueueService.getWorkflowAudit(this.workQueueItem['guid'], "").subscribe(resp => {
      this.workFlowAudit = resp;
      this.setWorkFlowDataForStageTimeline();
    });

  }

  counter = 0;
  setWorkFlowDataForStageTimeline() {
    if (this.commonUtility.isArrayIterable(this.workFlowAudit) && this.commonUtility.isArrayIterable(this.stageList)) {
      this.workFlowAudit.forEach(workflowItem => {
        let stageIndx = this.stageList.findIndex(stageData => stageData.lookupKey == workflowItem.stageCd);
        if (stageIndx > -1) {
          this.stageList[stageIndx]['workflowData'] = workflowItem;
        }
      });
    } else {
      if (this.counter < 3) {
        setTimeout(() => {
          this.counter += 1;
          this.setWorkFlowDataForStageTimeline();
        }, 500);
      }
    }
  }

  expandStageTimelineCard(index) {
    if (this.commonUtility.isArrayIterable(this.stageList) && this.stageList[index]['workflowData']) {
      this.stageList[index].isExpanded = !this.stageList[index].isExpanded;
    }
  }

  demoStageList = [
    {
        "parentObject": null,
        "versionId": null,
        "guid": null,
        "createdDt": null,
        "updatedDt": 1692602988520,
        "createdUser": null,
        "updatedUser": null,
        "baseCompanyCd": null,
        "versionNum": null,
        "workflowStatusCd": null,
        "shareByRegionalOfc": null,
        "exceptionDOList": null,
        "businessKey": null,
        "statusCd": null,
        "applicableCountryCd": null,
        "applicableComponentCd": null,
        "txStatusCd": null,
        "txStageCd": null,
        "txDecisionCd": null,
        "submissionModeCd": null,
        "stageCd": null,
        "checkersDecision": null,
        "checkersRemarks": null,
        "checkersDicisionDt": null,
        "id": null,
        "lookupCd": "ClaimStateCd",
        "lookupKey": "PENDING_DE",
        "lookupValue": "Data Entry",
        "lookupAddValue1": "null",
        "defaultFl": null,
        "sortOrder": 1,
        "parentLookupCd": null,
        "displayFl": null,
        "criteriaLookupKey": null,
        "lookupValueKey": null,
        "lookupAddValue2": "null",
        "objectName": "LookupDataDO",
        "code": null,
        "referenceNum": null,
        "baseAdditionalFields": null
    },
    {
        "parentObject": null,
        "versionId": null,
        "guid": null,
        "createdDt": null,
        "updatedDt": 1692602988520,
        "createdUser": null,
        "updatedUser": null,
        "baseCompanyCd": null,
        "versionNum": null,
        "workflowStatusCd": null,
        "shareByRegionalOfc": null,
        "exceptionDOList": null,
        "businessKey": null,
        "statusCd": null,
        "applicableCountryCd": null,
        "applicableComponentCd": null,
        "txStatusCd": null,
        "txStageCd": null,
        "txDecisionCd": null,
        "submissionModeCd": null,
        "stageCd": null,
        "checkersDecision": null,
        "checkersRemarks": null,
        "checkersDicisionDt": null,
        "id": null,
        "lookupCd": "ClaimStateCd",
        "lookupKey": "pendingautoadj",
        "lookupValue": "Auto Underwriting",
        "lookupAddValue1": "null",
        "defaultFl": null,
        "sortOrder": 2,
        "parentLookupCd": null,
        "displayFl": null,
        "criteriaLookupKey": null,
        "lookupValueKey": null,
        "lookupAddValue2": "null",
        "objectName": "LookupDataDO",
        "code": null,
        "referenceNum": null,
        "baseAdditionalFields": null
    },
    {
        "parentObject": null,
        "versionId": null,
        "guid": null,
        "createdDt": null,
        "updatedDt": 1692602988520,
        "createdUser": null,
        "updatedUser": null,
        "baseCompanyCd": null,
        "versionNum": null,
        "workflowStatusCd": null,
        "shareByRegionalOfc": null,
        "exceptionDOList": null,
        "businessKey": null,
        "statusCd": null,
        "applicableCountryCd": null,
        "applicableComponentCd": null,
        "txStatusCd": null,
        "txStageCd": null,
        "txDecisionCd": null,
        "submissionModeCd": null,
        "stageCd": null,
        "checkersDecision": null,
        "checkersRemarks": null,
        "checkersDicisionDt": null,
        "id": null,
        "lookupCd": "ClaimStateCd",
        "lookupKey": "pendingmadj",
        "lookupValue": "Manual Underwriting",
        "lookupAddValue1": "null",
        "defaultFl": null,
        "sortOrder": 3,
        "parentLookupCd": null,
        "displayFl": null,
        "criteriaLookupKey": null,
        "lookupValueKey": null,
        "lookupAddValue2": "null",
        "objectName": "LookupDataDO",
        "code": null,
        "referenceNum": null,
        "baseAdditionalFields": null
    },
    {
        "parentObject": null,
        "versionId": null,
        "guid": null,
        "createdDt": null,
        "updatedDt": 1692602988520,
        "createdUser": null,
        "updatedUser": null,
        "baseCompanyCd": null,
        "versionNum": null,
        "workflowStatusCd": null,
        "shareByRegionalOfc": null,
        "exceptionDOList": null,
        "businessKey": null,
        "statusCd": null,
        "applicableCountryCd": null,
        "applicableComponentCd": null,
        "txStatusCd": null,
        "txStageCd": null,
        "txDecisionCd": null,
        "submissionModeCd": null,
        "stageCd": null,
        "checkersDecision": null,
        "checkersRemarks": null,
        "checkersDicisionDt": null,
        "id": null,
        "lookupCd": "ClaimStateCd",
        "lookupKey": "CLAIMREJECT",
        "lookupValue": "Claim Rejected\t",
        "lookupAddValue1": "null",
        "defaultFl": null,
        "sortOrder": 99,
        "parentLookupCd": null,
        "displayFl": null,
        "criteriaLookupKey": null,
        "lookupValueKey": null,
        "lookupAddValue2": "null",
        "objectName": "LookupDataDO",
        "code": null,
        "referenceNum": null,
        "baseAdditionalFields": null
    },
    {
        "parentObject": null,
        "versionId": null,
        "guid": null,
        "createdDt": null,
        "updatedDt": 1692602988520,
        "createdUser": null,
        "updatedUser": null,
        "baseCompanyCd": null,
        "versionNum": null,
        "workflowStatusCd": null,
        "shareByRegionalOfc": null,
        "exceptionDOList": null,
        "businessKey": null,
        "statusCd": null,
        "applicableCountryCd": null,
        "applicableComponentCd": null,
        "txStatusCd": null,
        "txStageCd": null,
        "txDecisionCd": null,
        "submissionModeCd": null,
        "stageCd": null,
        "checkersDecision": null,
        "checkersRemarks": null,
        "checkersDicisionDt": null,
        "id": null,
        "lookupCd": "ClaimStateCd",
        "lookupKey": "pendingpayoutclearance",
        "lookupValue": "Payment",
        "lookupAddValue1": "null",
        "defaultFl": null,
        "sortOrder": 4,
        "parentLookupCd": null,
        "displayFl": null,
        "criteriaLookupKey": null,
        "lookupValueKey": null,
        "lookupAddValue2": "null",
        "objectName": "LookupDataDO",
        "code": null,
        "referenceNum": null,
        "baseAdditionalFields": null
    },
    {
        "parentObject": null,
        "versionId": null,
        "guid": null,
        "createdDt": null,
        "updatedDt": 1692602988520,
        "createdUser": null,
        "updatedUser": null,
        "baseCompanyCd": null,
        "versionNum": null,
        "workflowStatusCd": null,
        "shareByRegionalOfc": null,
        "exceptionDOList": null,
        "businessKey": null,
        "statusCd": null,
        "applicableCountryCd": null,
        "applicableComponentCd": null,
        "txStatusCd": null,
        "txStageCd": null,
        "txDecisionCd": null,
        "submissionModeCd": null,
        "stageCd": null,
        "checkersDecision": null,
        "checkersRemarks": null,
        "checkersDicisionDt": null,
        "id": null,
        "lookupCd": "ClaimStateCd",
        "lookupKey": "claimfinal",
        "lookupValue": "Generate Policy",
        "lookupAddValue1": "null",
        "defaultFl": null,
        "sortOrder": 7,
        "parentLookupCd": null,
        "displayFl": null,
        "criteriaLookupKey": null,
        "lookupValueKey": null,
        "lookupAddValue2": "null",
        "objectName": "LookupDataDO",
        "code": null,
        "referenceNum": null,
        "baseAdditionalFields": null
    }
];

}
